/**
 * Lesen des Vertrauens-Badges auf der Client-Seite.
 *
 * Geschrieben wird `profile.metadata.stripeVerified` ausschliesslich ueber die
 * Integration API (server/api/sync-stripe-status.js und der taegliche
 * Scheduler-Lauf). Der Nutzer selbst kann es nicht setzen — genau deshalb steht
 * es in metadata und nicht in publicData, das `sdk.currentUser.updateProfile`
 * jedem Anbieter freigibt.
 */

/**
 * Traegt dieser Nutzer das Badge?
 *
 * Verlangt ein ausdrueckliches `true`. Alles andere — false, null, undefined —
 * heisst "kein Badge". `undefined` ist nicht von "noch nie geprueft" zu
 * unterscheiden, und ein Vertrauenszeichen im Zweifel zu zeigen waere die
 * falsche Richtung. Dieselbe Regel wie bei requiresSoftReservationFallback.
 *
 * Wichtig fuer Kartenflaechen: `profile.metadata` kommt nur mit, wenn die
 * jeweilige Query es im `fields.user`-Sparse-Fieldset anfordert. Fehlt es,
 * liefert diese Funktion `false` — das Badge verschwindet still, statt etwas
 * Falsches zu behaupten.
 *
 * @param {Object} user denormalisierte Nutzer-Entitaet (z. B. listing.author)
 * @returns {boolean}
 */
export const isVerifiedProvider = user =>
  user?.attributes?.profile?.metadata?.stripeVerified === true;

/**
 * Zeitpunkt des letzten Uebergangs auf "verifiziert", als ISO-String.
 *
 * ⚠️ NICHT als Erstverifizierung lesen: oeffnet Stripe voruebergehend eine
 * faellig werdende Anforderung (eventually_due wandert nach currently_due,
 * waehrend das Konto voll funktionsfaehig bleibt), nimmt das Praedikat das Badge
 * zurueck und praegt den Stempel danach neu. Er bedeutet "seit wann
 * ununterbrochen verifiziert". Siehe server/api-util/stripeVerification.js.
 *
 * @param {Object} user
 * @returns {string|null}
 */
export const verifiedSince = user =>
  isVerifiedProvider(user) ? user?.attributes?.profile?.metadata?.stripeVerifiedAt || null : null;
